import '@/styles/global.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import alertStore from './store/alert';
import {
	Input,
	Tooltip,
	Button,
	Form,
	Spin,
	Alert,
	Drawer,
	Dropdown,
	Divider,
	Menu,
	Collapse,
	Breadcrumb,
	Image,
	Switch,
	Empty,
	Skeleton,
	Radio,
	Tag,
	Badge
} from 'ant-design-vue';

const app = createApp(App);

// use components
app
	.use(Input)
	.use(Tooltip)
	.use(Button)
	.use(Form)
	.use(Spin)
	.use(Alert)
	.use(Drawer)
	.use(Dropdown)
	.use(Divider)
	.use(Menu)
	.use(Collapse)
	.use(Breadcrumb)
	.use(Image)
	.use(Switch)
	.use(Empty)
	.use(Skeleton)
	.use(Radio)
	.use(Tag)
	.use(Badge);

app.use(alertStore);
app.use(router);
app.mount('#app');
